import React, { useEffect, useState } from 'react'
import room from '../Services/room'
import userService from '../Services/user'
import ActualRoom from './ActualRoom'
function RoomAuth(props) {
    const [isAuthen, setIsAuthen] = useState(false)

    useEffect(()=>{
        if(userService.isAuthenticated()){
            var user = userService.getCurrentUser()
            if(props.room){
                if(user.roomName === props.room.roomName){
                    setIsAuthen(true)
                }
            }
        }

    },[props.room])
    return (
        <div>
            {
                isAuthen ? (<ActualRoom room={props.room} />) : (
                    <div>
                        Please Join the room here
                        <p>Join Room Form</p>
                    </div>
                )
            }
        </div>
    )
}

export default RoomAuth
